<template>
  <div class="notice-detail">
    <breadcrumb :list="breadcrumbList"></breadcrumb>
    <el-card style="margin: 20px; padding: 28px 20px; position: relative">
      <img
        class="delivery-status"
        v-if="data.is_sign === 1 && data.is_delivered === 1"
        src="../../../assets/img/delivered.png"
        alt=""
      />
      <img
        class="delivery-status"
        v-else-if="data.is_sign === 1 && data.is_delivered === 0"
        src="../../../assets/img/undelivered.png"
        alt=""
      />
      <div class="subject">
        <h1 class="h1-title">{{ data.title }}</h1>
        <div class="div-other">
          <el-col :span="12" class="col-content-left">
            <span class="title">发布人:</span>
            <span class="title text-b omitted">{{ data.creator }}</span>
          </el-col>
          <el-col :span="12" class="col-content col-content-right">
            <span class="title">发布单位:</span>
            <span class="title text-b omitted">{{ data.creator_unit }}</span>
          </el-col>
        </div>
        <div class="line"></div>
        <div class="div-other m-top">
          <el-col
            :xl="8"
            :lg="8"
            :md="12"
            :sm="12"
            :xs="24"
            class="col-content"
          >
            <span class="title text-color">紧急程度:</span>
            <span class="title red-text m-left omitted">
              {{ getstatus(data.level) }}
            </span>
          </el-col>
          <el-col
            :xl="8"
            :lg="8"
            :md="12"
            :sm="12"
            :xs="24"
            class="col-content col-content-center"
          >
            <span class="title text-color">登记人:</span>
            <span class="title m-left omitted">{{ data.registrant }}</span>
          </el-col>
          <el-col
            :xl="8"
            :lg="8"
            :md="12"
            :sm="12"
            :xs="24"
            class="col-content-right"
            v-if="data.push_time"
          >
            <span class="title text-color">发布日期:</span>
            <span class="title m-left">{{ data.push_time | formatDate }}</span>
          </el-col>
        </div>
        <div class="div-content">
          <p class="p-title">{{ data.description }}</p>
        </div>
        <div v-html="data.content"></div>
      </div>
      <div class="subject_btn" style="text-align: center; margin-top: 35px">
        <el-button type="info" @click="$router.back(-1)">返回</el-button>
        <el-button
          type="primary"
          v-if="data.is_sign == 1 && data.is_delivered == 0"
          @click="getstatus1()"
          >签收</el-button
        >
      </div>
    </el-card>
    <!-- 新增 -->
    <el-dialog
      :visible.sync="dialogVisible"
      center
      width="35%"
      :before-close="hide"
      class="dialog"
    >
      <template #title>
        <div
          style="
            font-size: 20px;
            font-weight: 500;
            color: #6345d5;
            border-bottom: 1px #6345d5 solid;
            padding-bottom: 15px;
          "
        >
          {{ visibleTitle }}
        </div>
      </template>
      <div class="receiptForm">
        <el-form
          :model="addForm"
          ref="addFormRef"
          :rules="addFormRules"
          label-width="auto"
        >
          <el-form-item label="回执描述" prop="receipt">
            <el-input
              v-model="addForm.receipt"
              clearable
              type="textarea"
              showWordLimit
              resize="none"
              maxlength="200"
              rows="5"
            />
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="hide">取 消</el-button>
        <el-button type="primary" @click="submit" :loading="submitBtnLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getNoticeItem, getLevel, receiptNotice } from '@/api/user'
import { formatDate } from '@/utils'
export default {
  name: 'NoticeDetail',
  data() {
    return {
      breadcrumbList: [
        // 面包屑所需数据
        { name: '通知公告', path: 'notice' },
        { name: '详情', path: 'notice_detail' }
      ],
      // 展示数据
      data: {
        tztg_fbrq: ''
      },
      // 紧急程度字典数据
      levalData: [],
      // 回执弹窗标题
      visibleTitle: '回执内容',
      // 回执弹窗是否显示
      dialogVisible: false,
      addFormRef: '',
      submitBtnLoading: false,
      // 回执表单数据
      addForm: {
        notice_id: this.$route.query.id,
        receipt: ''
      },
      // 回执表单校验规则
      addFormRules: {
        receipt: [
          { required: true, message: '请输入回执描述', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getLevelData()
    this.info()
  },
  methods: {
    // 获取紧急程度字典数据
    async getLevelData() {
      getLevel().then((res) => {
        this.levalData = res
      })
    },
    // 紧急程度根据字典数据过滤
    getstatus(val) {
      const status = this.levalData.find((item) => item.code == val)
      return status ? status.title : ''
    },
    // 格式化日期
    formatDate(val) {
      if (!val && val != 0) return
      return formatDate(val)
    },
    // 获取通知公告详情展示数据
    async info() {
      const res = await getNoticeItem(this.$route.query.id)
      this.data = res
    },
    // 签收
    async getstatus1() {
      this.dialogVisible = true
    },
    // 隐藏清除表单数据
    hide() {
      this.dialogVisible = false
      if (this.$refs['addFormRef'] !== undefined) {
        this.$refs['addFormRef'].resetFields()
      }
      this.addForm.receipt = ''
      this.addForm.describe = ''
    },
    // 提交回执表单
    async submit() {
      console.log(this.visibleState)
      this.submitBtnLoading = true

      this.$refs['addFormRef'].validate(async (valid) => {
        if (valid) {
          const res = await receiptNotice(this.addForm)
          console.log('123', res)
          this.$message({
            message: '签收成功！',
            type: 'success'
          })
          this.hide()
          this.info()
        } else {
          console.log('error submit!!')
          return false
        }
      })

      this.submitBtnLoading = false
    }
  }
}
</script>
<style lang="less" scoped>
.notice-detail {
  .delivery-status {
    position: absolute;
    top: 0;
    right: 0;
  }
  .col-content {
    display: flex;
    align-items: center;
  }
  .red-text {
    color: #f00;
  }
  .p-title {
    margin-top: 20px !important;
    padding: 0 !important;
    width: 100%;
    text-align: center;
  }
  .col-content-left {
    text-align: left;
    display: flex;
    align-items: center;
  }
  .col-content-right {
    padding-right: 20px !important;
    text-align: right;
    display: flex;
    align-items: center;
  }
  .col-content-center {
    text-align: center;
  }
  .text-color {
    font-size: 14px;
    color: #888 !important;
  }
  .text-b {
    margin-left: 10px;
    font-size: 14px;
    color: #6345d5 !important;
  }
  .h1-title {
    padding: 0 !important;
    margin: 5px 0 20px 0;
    width: 100%;
    text-align: center;
  }
  .div-other {
    height: 30px;
  }
  .line {
    height: 2px;
    border-bottom: 1px solid #ccc;
  }
  .m-left {
    margin-left: 10px !important;
  }
  .m-top {
    margin-top: 10px !important;
  }

  .omitted {
    width: calc(100% - 80px);
    // calc(100% - 70px)
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }
  /deep/ .el-dialog {
    width: 40% !important;
    min-width: 0 !important;
  }
  .receiptForm {
    margin-top: 15px;
  }
  /deep/ .dialog-footer {
    margin-bottom: 20px;
  }
}
</style>
